// Copyright 2025 - Hewlett Packard Enterprise Company
import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Text, DropButton, Button, Heading } from 'grommet';
import { MoreVertical, FormClose, Chat } from 'grommet-icons';
import PropTypes from 'prop-types';
import ExternalAnchor from '../ExternalAnchor/ExternalAnchor';
import { ChatContext } from '../../providers/ChatProvider';

export default function ChatHeader({ onClose }) {
  const { t } = useTranslation('common');
  const [openDropMenu, setOpenDropMenu] = useState();
  const { clearConversations } = useContext(ChatContext);

  const onCloseChatBot = () => {
    // treat escape/clicking outside the same
    onClose();
  };

  return (
    <Box
      data-testid="chat-header"
      justify="between"
      flex={false}
      gap="small"
      background="background-front"
      style={{
        position: 'sticky',
        top: 0,
      }}
      direction="row"
      pad={{ right: 'small' }}
    >
      <DropButton
        label={<MoreVertical size="small" />}
        open={openDropMenu}
        onOpen={() => setOpenDropMenu(true)}
        onClose={() => setOpenDropMenu(false)}
        dropContent={
          <>
            <Button
              default
              kind="option"
              icon={<Chat />}
              label={t('chat.new_chat')}
              onClick={() => {
                clearConversations(); // Clear the conversations
                setOpenDropMenu(false);
              }}
              data-testid="clear-conversations-button"
              style={{
                display: 'flex',
              }}
            />
            <Box border="top" pad="xsmall">
              <Button default>
                <ExternalAnchor href="https://www.hpe.com/us/en/legal/privacy.html#privacystatement">
                  {t('chat.hpe_privacy_policy')}
                </ExternalAnchor>
              </Button>
            </Box>
          </>
        }
        dropAlign={{
          left: 'left',
          top: 'bottom',
        }}
        data-testid="chat-header-drop-button"
      />
      <Box direction="row" gap="xxsmall" alignSelf="center">
        <Heading margin="none" level={2}>
          {t('chat.chat_title')}
        </Heading>
        <Box style={{ position: 'relative', top: '-0.5em' }}>
          <Text size="small">{t('chat.chat_title_beta')}</Text>
        </Box>
      </Box>
      <Button default icon={<FormClose />} onClick={onCloseChatBot} />
    </Box>
  );
}

ChatHeader.propTypes = {
  onClose: PropTypes.func.isRequired,
};
